
import { defineComponent } from 'vue';
import { AppCard, AppButton, AppSimpleTable } from '@/components';
import { useArenaItemDetail } from '@/modules/arena/item/model/detail';
import { formatDate, renderOption, renderTimeUnit } from '@/common/utils/helpers';
import { ArenaTicketTypeList } from '@/modules/arena/ticket/model/mixins';
import { ArenaStatusList } from '@/modules/arena/item/model/mixins';

import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.ITEM.DETAIL,
    components: { AppCard, AppButton, AppSimpleTable },
    setup() {
        const { model, actions } = useArenaItemDetail();

        return {
            model,
            formatDate,
            actions,
            ArenaTicketTypeList,
            ArenaStatusList,
            renderOption,
            renderTimeUnit,
            ROUTE_NAME_ARENA,
            ROUTE_NAME_GAME
        };
    }
});
